export const mutations = {
  STORE_COMMISSIONS(state, commissions) {
    state.commissions = commissions;
  },
  STORE_COMMISSION_UPDATE(state, commissionId) {
    let Commission = state.commissions.find(function(commission) {
      return commission.id === commissionId;
    });
    state.systemCommission = Commission;
  },

  addCommissionItems(state) {
    state.commission_items.push({
      description: "",
      amount: "",
      total_price: ""
    });
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/commissions/mutations.js